import * as ss from 'superstruct';

/** Reads through a Dialpad connection's company admin API key. */
export const DialpadInputStreamSource = ss.type({
  name: ss.literal('dialpad'),
});

export type DialpadInputStreamSource = ss.Infer<
  typeof DialpadInputStreamSource
>;
